export const metaradarCooldownMessage = (retryAfterSeconds: number): string => {
	if (retryAfterSeconds < 60) {
		return 'Please wait less than a minute before refreshing Metaradar again.';
	}

	const minutes = Math.ceil(retryAfterSeconds / 60);
	if (minutes < 60) {
		return `Please wait ${minutes} ${minutes === 1 ? 'minute' : 'minutes'} before refreshing Metaradar again.`;
	}

	const hours = Math.ceil(minutes / 60);
	return `Please wait ${hours} ${hours === 1 ? 'hour' : 'hours'} before refreshing Metaradar again.`;
};
